import { parseBoolean } from '../../shared/utils/bool.utils';

// TODO: Separate Archive and Generate tabs content into two components.
class MarketingController {
  constructor(MarketingApiService, DashboardApiService, BannerImagePreviewFactory, SessionService, StorageService, $timeout) {
    'ngInject';

    this.MarketingApiService = MarketingApiService;
    this.DashboardApiService = DashboardApiService;
    this.BannerImagePreviewFactory = BannerImagePreviewFactory;
    this.SessionService = SessionService;
    this.StorageService = StorageService;
    this.state = { banner: null, allowDownload: true};
    this.activateLater = false;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.checkHasConfirmTermsAndCondition();
    this.MarketingApiService.getBannerList().then(list => this.list = list);
    this.MarketingApiService.getReferralLinks().then(links => this.links = links);
    this.account = {
      availableBalance: null,
    };
    this.currency = this.SessionService.get('currency');
    this.customerProducts = {
      products: null,
      availableBalance: null,
    }

    this.renderTable();

  }

  checkHasConfirmTermsAndCondition() {
    this.DashboardApiService.condition().then(resp => {
      let showModal = this.StorageService.getItem('show_activation_modal');
      if (parseBoolean(showModal) && !this.activateLater && resp.user.activation_code) {
        if (resp.user.activation_timestamp == resp.user.activation_sent_timestamp) {
          $('#activation-modal').show();
          return false;
        }
      }

      //Check if confirmed terms & condition
      if (resp.has_confirm_terms_and_conditions == false) {
        $('#welcome-affiliate-modal').show();
        $('#get-started').click(() => {
          $('#welcome-affiliate-modal').hide();
        });
      }
    });
  }

  activateLaterAction() {
    this.activateLater = true;
    this.StorageService.setItem('show_activation_modal', false);
    $('#activation-modal').hide();
    this.checkHasConfirmTermsAndCondition();
  }

  confirmModal() {
    $('#confirm-affiliate').attr('disabled', true);
    $('#get-started').removeAttr('disabled');
  }

  async onSubmitConfirmation() {
    this.MarketingApiService.confirm();
  }

  renderTable() {
    this.$timeout(() => {
      $( window ).resize(function() {
        $('#datatable-responsive').footable();
        $('#datatable-responsive').trigger('footable_redraw');
      });
      $(window).trigger('resize');

      window.dispatchEvent(new Event('resize'));

      var evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    }, 0);
  }

  async onSuccessfulSubmission(response) {
    let detailsContainer = document.getElementsByClassName('referral-code-wrap')[0];
    detailsContainer.classList.remove('hidden');

    // Display the generated tracking code.
    document.getElementById('referral-url').value = response.referral_link;
    document.getElementById('referral-code').value = response.tracking_html_code;
    this.trackingCode = response.tracking_html_code;

    // refresh the list.
    this.MarketingApiService.getBannerList().then(list => this.list = list);
    this.MarketingApiService.getReferralLinks().then(links => this.links = links);
  }

  onFormReset() {
    let detailsContainer = document.getElementsByClassName('referral-code-wrap')[0];
    detailsContainer.classList.add('hidden');
  }

  onReferralLinkSelected(link) {
    document.getElementById('referralLink').value = link;
  }

  previewBanner(filename, allowDownload) {
    this.setState('allowDownload', allowDownload);
    this.BannerImagePreviewFactory.preview(filename).then(banner => this.banner = banner);
  }

  setState(key, value) {
    this.state[key] = value;
  }

  onCustomerProductsLoaded(customerProductsList) {
    this.account.availableBalance = customerProductsList.balance;
    this.renderTable();
  }
}

export default MarketingController;



// WEBPACK FOOTER //
// ./client/app/pages/marketing/marketing.controller.js